import store from '../../Redux/store';
import Logger from '../Logging';

const INFO = 'Utilities/Gnural/ReduxConnector';

export class ReduxConnector {
	constructor(store) {
		this.store = store;
		this.currentStore = store.getState();
		this.callbacks = [];
		this.disposed = false;

		this.onStoreUpdate = this.onStoreUpdate.bind(this);
		this.connect = this.connect.bind(this);
		this.dispose = this.dispose.bind(this);

		this.unsubscribeFromStore = this.store.subscribe(this.onStoreUpdate);
	}

	dispose() {
		if (this.disposed) { return; }

		this.disposed = true;

		if (this.unsubscribeFromStore) {
			this.unsubscribeFromStore();
			this.unsubscribeFromStore = null;
		}

		this.store = null;
		this.currentStore = null;
		this.callbacks = [];
	}

	connect(neededStoreVariables, updateFunction) {
		if (this.disposed ||
			!neededStoreVariables ||
			typeof(neededStoreVariables) !== 'function' ||
			!updateFunction || typeof(updateFunction) !== 'function'
		) {
			return;
		}
		try {
			const result = neededStoreVariables(this.currentStore);
			updateFunction(result);
			this.callbacks.push([neededStoreVariables, updateFunction, result]);
		} catch (e) {
			Logger.error(INFO, 'Failed to Connect', e);
		}
	}

	onStoreUpdate() {
		if (this.disposed || !this.store) { return; }

		const newStore = this.store.getState();
		this.currentStore = newStore;

		let result;
		this.callbacks.forEach( (callback) => {
			try {
				result = callback[0](newStore);
				if (result === callback[2]) {
					return;
				}
				callback[2] = result;
				callback[1](result);
			} catch (e) {
				Logger.error(INFO, 'Failed to Update Function', e);
			}
		});
	}

	dispatch(dispatch) {
		if (this.disposed || !this.store) {
			Logger.warn(INFO, 'Tried to Dispatch Redux Action, but Connector is Disposed');
			return;
		}
		this.store.dispatch(dispatch);
	}
}

export function CreateReduxConnector() {
	return new ReduxConnector(store);
}